import { Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./component/navbar/Navbar";
import Home from "./component/home/Home";
import EmailMarketing from "./component/email-marketing/EmailMarketing";

import EmailTxt from "./component/email-txt/EmailTxt";
import Login from "./component/login/Login";
import User from "./component/createUser/User";
import ProtectedRoute from "./component/protectedroute/ProtectedRoute";
import ClientEntryForm from "./component/client-entry-form/ClientEntryForm";
import PotentialClient from "./component/potential-client/PotentialClient";
import ViewPotentialClient from "./component/potential-client/ViewPotentialClient";
import UpdatePassword from "./component/updatePassword/UpdatePassword";

import ForgetPage from "./component/forgetpage/ForgetPage";
import ResetPasswordPage from "./component/forgetpage/ResetPasswordPage";
import ChangeEmailId from "./component/change-email-id/ChangeEmailId";
import MultipleEmailMarketing from "./component/email-marketing/MultipleEmailMarketing";
import CodeAsifMultipleEmail from "./component/codeasif/CodeAsifMultipleEmail";

function App() {
  return (
    <>
      <div className="app-container">
        <Navbar></Navbar>
        <Routes>
          <Route element={<ProtectedRoute></ProtectedRoute>}>
            <Route path="/" element={<Home></Home>}></Route>
            <Route
              path="/marketing/emailmarketing"
              element={<EmailMarketing></EmailMarketing>}
            ></Route>
            <Route
              path="/marketing/multipleemailmarketing"
              element={<MultipleEmailMarketing></MultipleEmailMarketing>}
            ></Route>
            <Route
              path="/marketing/emailtxt"
              element={<EmailTxt></EmailTxt>}
            ></Route>
            <Route path="/marketing/codeasifemail" element={<CodeAsifMultipleEmail></CodeAsifMultipleEmail>}></Route>
            <Route path="/user/createuser" element={<User></User>}></Route>
            <Route
              path="/client/createclient"
              element={<ClientEntryForm></ClientEntryForm>}
            ></Route>
            <Route
              path="/client/potentialclient"
              element={<PotentialClient></PotentialClient>}
            ></Route>
            <Route
              path="/viewpotentialclient/:id"
              element={<ViewPotentialClient></ViewPotentialClient>}
            ></Route>
            <Route
              path="/setting/updatepassword"
              element={<UpdatePassword></UpdatePassword>}
            ></Route>
            <Route
              path="/setting/chnageemail"
              element={<ChangeEmailId></ChangeEmailId>}
            ></Route>
          </Route>
          <Route path="/login" element={<Login></Login>}></Route>
          <Route path="/forgetpage" element={<ForgetPage></ForgetPage>}></Route>
          <Route
            path="/resetpassword"
            element={<ResetPasswordPage></ResetPasswordPage>}
          ></Route>
        </Routes>
      </div>
    </>
  );
}

export default App;
